import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-btn-list",
  templateUrl: "./btn-list.component.html",
  styleUrls: ["./btn-list.component.scss"],
})
export class BtnListComponent implements OnInit, OnChanges {
  @Input() target: string = "";
  @Input() action: string = "";
  @Input() type_id: string = "";

  public route: string[] = [];

  constructor(private activatedRoute: ActivatedRoute) {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    let target = this.target.split("/");

    let tab_from = this.activatedRoute.snapshot.queryParams["tab_from"];

    if (tab_from) {
      target = tab_from.split("/");
    }
    this.route = ["/", ...target, this.action].filter((item) => item);
  }
}
